var _rect, _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _path9, _path0, _path1, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _g5, _path16, _path17, _g6, _path18, _path19, _g7, _path20, _path21, _g8, _path22, _path23, _g9, _path24, _path25, _g0, _path26, _path27, _g1, _path28, _path29, _g10, _path30, _g11, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 85,
    viewBox: "0 0 89 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.8103,
    y: 5.32371,
    width: 50.2975,
    height: 64.3048,
    transform: "rotate(13.0227 27.8103 5.32371)",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 77,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8111 0.253906L83.189 9.09477L73.04 84.1459L7.66215 75.305L17.8111 0.253906Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 77,
    height: 84
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0172 0.789237L83.0021 14.6274L66.8009 83.6895L7.81446 69.8525L24.0172 0.789237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 77,
    height: 84
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0172 0.789237L83.0021 14.6274L66.8009 83.6895L7.81446 69.8525L24.0172 0.789237Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4881 13.5687L28.6377 1.87326C28.3508 1.80661 28.0601 1.76862 27.7668 1.75947C27.4722 1.75015 27.1791 1.76889 26.8886 1.81718C26.5983 1.86417 26.3161 1.9401 26.0407 2.04351C25.764 2.14673 25.501 2.27701 25.2518 2.43173C25.0014 2.58626 24.769 2.76447 24.5533 2.96617C24.3378 3.16656 24.1449 3.38594 23.9719 3.62525C23.8002 3.86474 23.6534 4.11687 23.5308 4.38556C23.4084 4.65294 23.3138 4.93071 23.246 5.2161L9.10603 65.491C9.03937 65.7778 9.00026 66.0671 8.99094 66.3617C8.98161 66.6563 9.00053 66.9481 9.04882 67.2386C9.09711 67.5291 9.17157 67.8124 9.27627 68.088C9.37968 68.3633 9.50865 68.6262 9.66319 68.8767C9.81903 69.1273 9.99724 69.3597 10.1976 69.5752C10.398 69.7907 10.6187 69.9837 10.8567 70.1566C11.0962 70.3283 11.3496 70.4753 11.617 70.5977C11.8844 70.7201 12.1622 70.8147 12.4489 70.8827L62.2982 82.5766C62.585 82.6432 62.8756 82.6825 63.1702 82.6919C63.4635 82.701 63.7566 82.6823 64.0471 82.634C64.3376 82.5857 64.6209 82.5112 64.8963 82.4078C65.1718 82.3031 65.4347 82.1741 65.6852 82.0196C65.9345 81.8636 66.168 81.6869 66.3824 81.485C66.5979 81.2846 66.7922 81.0641 66.9638 80.8259C67.1355 80.5864 67.2825 80.333 67.4049 80.0656C67.5273 79.7982 67.6232 79.5206 67.6912 79.2339L81.831 18.9604C81.8976 18.6735 81.9356 18.3828 81.9448 18.0895C81.9541 17.7948 81.9353 17.5017 81.887 17.2113C81.8401 16.921 81.7641 16.6387 81.6607 16.3634C81.5575 16.0867 81.4272 15.8236 81.2725 15.5745C81.118 15.324 80.9398 15.0916 80.7381 14.876C80.5377 14.6605 80.3183 14.4676 80.079 14.2946C79.8408 14.1231 79.5874 13.976 79.3187 13.8534C79.0513 13.7311 78.7735 13.6364 78.4881 13.5687ZM38.0118 74.0064C37.864 73.9705 37.7194 73.9218 37.5794 73.8578C37.4406 73.7952 37.309 73.719 37.1844 73.6292C37.0599 73.5394 36.9461 73.4391 36.8404 73.3279C36.7362 73.2157 36.6438 73.0944 36.5632 72.9641C36.4827 72.8338 36.4149 72.6972 36.3612 72.5546C36.3077 72.4107 36.2692 72.2636 36.2445 72.1129C36.2199 71.961 36.2098 71.8097 36.2146 71.6565C36.2194 71.5032 36.2399 71.3521 36.2746 71.2029C36.3094 71.0537 36.3593 70.9105 36.422 70.7704C36.4859 70.6317 36.5621 70.5001 36.6519 70.3755C36.7404 70.2508 36.8422 70.1359 36.9531 70.0315C37.0654 69.9273 37.1867 69.8349 37.317 69.7543C37.446 69.6736 37.5839 69.606 37.7265 69.5523C37.8704 69.4988 38.0177 69.459 38.1683 69.4343C38.3189 69.4095 38.4714 69.4009 38.6246 69.4057C38.7779 69.4105 38.929 69.431 39.0782 69.4657C39.2261 69.5003 39.3706 69.5504 39.5107 69.6131C39.6494 69.677 39.781 69.7532 39.9056 69.843C40.0303 69.9315 40.1441 70.0318 40.2496 70.1442C40.3538 70.2565 40.4462 70.3778 40.527 70.5068C40.6075 70.6371 40.6753 70.7737 40.7288 70.9176C40.7823 71.0615 40.8208 71.2086 40.8455 71.3593C40.8703 71.5099 40.8802 71.6625 40.8754 71.8157C40.8706 71.969 40.8503 72.1188 40.8155 72.268C40.7808 72.4172 40.7307 72.5617 40.6681 72.7005C40.6041 72.8405 40.5279 72.9721 40.4381 73.0967C40.3496 73.2213 40.248 73.335 40.137 73.4394C40.0246 73.5449 39.9033 73.6373 39.773 73.7179C39.644 73.7986 39.5063 73.8649 39.3637 73.9186C39.2196 73.9734 39.0725 74.0119 38.9218 74.0366C38.7712 74.0614 38.6186 74.0713 38.4654 74.0665C38.3123 74.0604 38.161 74.0412 38.0118 74.0064ZM64.499 69.4802C64.4679 69.6126 64.4229 69.7392 64.3663 69.8629C64.3098 69.9866 64.2424 70.1023 64.1626 70.2122C64.0827 70.3221 63.9934 70.4228 63.8946 70.5156C63.7945 70.6082 63.6881 70.6894 63.5722 70.7613C63.4565 70.8319 63.3357 70.8912 63.2085 70.939C63.0815 70.9855 62.9519 71.021 62.8177 71.0427C62.6834 71.0643 62.5496 71.0728 62.4136 71.0676C62.2789 71.0627 62.1445 71.0459 62.0121 71.0147L17.847 60.6533C17.7146 60.6221 17.5865 60.5783 17.4639 60.5232C17.3402 60.4667 17.2233 60.3991 17.1132 60.3206C17.0033 60.2407 16.9011 60.1526 16.8083 60.0538C16.7155 59.955 16.6346 59.8472 16.5625 59.7326C16.4906 59.6168 16.4313 59.496 16.3833 59.3701C16.3355 59.2429 16.3001 59.112 16.277 58.9789C16.2553 58.8446 16.2456 58.7106 16.2507 58.5746C16.2544 58.4398 16.2712 58.3054 16.3022 58.1743L27.6856 9.64957C27.7168 9.51713 27.7605 9.39036 27.817 9.26665C27.8747 9.14442 27.9422 9.02751 28.0221 8.91757C28.1007 8.80746 28.1899 8.70675 28.29 8.61414C28.3887 8.52266 28.4966 8.44041 28.6123 8.36981C28.7269 8.29773 28.849 8.23862 28.976 8.19211C29.1019 8.14412 29.2326 8.11004 29.3668 8.0884C29.5013 8.06545 29.6351 8.05701 29.7711 8.06213C29.9058 8.06707 30.04 8.08522 30.1726 8.11509L74.3376 18.4765C74.4701 18.5076 74.5969 18.5513 74.7206 18.6078C74.8445 18.6631 74.9614 18.7306 75.0715 18.8092C75.1814 18.8891 75.2823 18.977 75.3749 19.0771C75.4677 19.1759 75.5501 19.2826 75.6222 19.3971C75.6941 19.513 75.7534 19.6338 75.8014 19.7597C75.8492 19.8869 75.8846 20.0177 75.9064 20.1507C75.9293 20.2852 75.9391 20.4192 75.934 20.5551C75.9303 20.69 75.9135 20.8244 75.8823 20.9568L64.499 69.4802Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 62,
    width: 7,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5123 62.9304L77.0284 63.5411L76.4179 68.0559L71.9018 67.4452L72.5123 62.9304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 63,
    width: 5,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7704 63.2358C73.5234 63.0672 72.3758 63.9402 72.207 65.1885C72.0384 66.4354 72.9129 67.582 74.1599 67.7506C75.4068 67.9192 76.5545 67.0461 76.7231 65.7992C76.8919 64.5509 76.0173 63.4044 74.7704 63.2358Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5123 62.9304L77.0284 63.5411L76.4179 68.0559L71.9018 67.4452L72.5123 62.9304Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 53,
    width: 7,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21727 53.9655L1.21387 53.289L0.582377 57.9588L5.58578 58.6354L6.21727 53.9655Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 53,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37814 53.3299L5.89424 53.9406L5.28372 58.4554L0.767621 57.8447L1.37814 53.3299Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 53,
    width: 5,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63619 53.6353C2.38925 53.4667 1.24159 54.3397 1.07279 55.588C0.904173 56.8349 1.77873 57.9815 3.02567 58.1501C4.27261 58.3187 5.42027 57.4456 5.58889 56.1987C5.75769 54.9504 4.88313 53.8039 3.63619 53.6353Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37827 53.3301L5.89436 53.9408L5.28384 58.4556L0.767743 57.8449L1.37827 53.3301Z",
    fill: "#D0BEDD"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 45,
    width: 7,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6359 46.5466L6.63254 45.87L5.95594 50.8734L10.9593 51.55L11.6359 46.5466Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 46,
    width: 6,
    height: 6
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93558 46.2385L11.4517 46.8492L10.841 51.3653L6.32488 50.7546L6.93558 46.2385Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 46,
    width: 6,
    height: 6
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19363 46.5438C7.94668 46.3752 6.79885 47.2496 6.63023 48.4965C6.46161 49.7435 7.33598 50.8913 8.58293 51.0599C9.82987 51.2286 10.9777 50.3542 11.1463 49.1072C11.3149 47.8603 10.4406 46.7125 9.19363 46.5438Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93558 46.2385L11.4517 46.8492L10.841 51.3653L6.32488 50.7546L6.93558 46.2385Z",
    fill: "#C4AED4"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5156 77.6962C70.6842 76.4495 71.8322 75.5756 73.0789 75.7442C74.3256 75.9128 75.2003 77.0602 75.0317 78.3069C74.8631 79.5537 73.7151 80.4276 72.4684 80.259C71.2216 80.0904 70.347 78.943 70.5156 77.6962Z",
    fill: "#D0BEDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 23.758C13.4006 22.9613 14.1342 22.4028 14.9309 22.5106C15.7276 22.6183 16.2866 23.3515 16.1788 24.1482C16.0711 24.9449 15.3375 25.5034 14.5408 25.3956C13.7441 25.2879 13.1852 24.5547 13.2929 23.758Z",
    fill: "#D0BEDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3113 32.8942C81.4292 32.0223 82.2317 31.411 83.1036 31.5289C83.9755 31.6468 84.5868 32.4493 84.4689 33.3212C84.351 34.1931 83.5485 34.8044 82.6766 34.6865C81.8047 34.5686 81.1934 33.7661 81.3113 32.8942Z",
    fill: "#D0BEDD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4031 24.5728C83.5717 23.3261 84.7197 22.4522 85.9664 22.6208C87.2131 22.7894 88.0878 23.9368 87.9192 25.1835C87.7506 26.4303 86.6026 27.3042 85.3559 27.1356C84.1092 26.967 83.2345 25.8196 83.4031 24.5728Z",
    fill: "#D0BEDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 17,
    width: 44,
    height: 28
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5136 17.5109L69.6866 26.7705L65.5053 44.4595L26.3324 35.1998L30.5136 17.5109Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 19,
    width: 40,
    height: 24
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8446 24.6809L39.3636 19.6032C34.4837 18.4497 29.5891 21.4753 28.4348 26.3586C27.2804 31.2421 30.3024 36.1387 35.1823 37.2922C38.5348 38.0846 41.884 36.9113 44.035 34.5173L49.9812 35.9229C50.833 39.0266 53.3021 41.5753 56.6546 42.3677C61.5344 43.5212 66.429 40.496 67.5833 35.6124C68.7376 30.7292 65.7241 25.8343 60.8446 24.6809Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5255 17.5141L26.3442 35.203L65.4927 44.4569L69.674 26.7679L30.5255 17.5141Z",
    fill: "#FFCA55"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 29,
    width: 5,
    height: 3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8199 29.0249L48.079 29.7952L47.6127 31.7678L44.3536 30.9975L44.8199 29.0249Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 29,
    width: 4,
    height: 3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6103 31.4891L45.3476 31.1907C44.8186 31.0656 44.4863 30.5276 44.6114 29.9982C44.7365 29.4689 45.2747 29.1363 45.8037 29.2613L47.0663 29.5598C47.595 29.6847 47.9272 30.2231 47.8021 30.7525C47.677 31.2818 47.1476 31.6162 46.6103 31.4891Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8395 29.0334L44.3834 30.9628L47.5741 31.717L48.0302 29.7876L44.8395 29.0334Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 30,
    width: 5,
    height: 3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0225 30.0181L52.2815 30.7884L51.8153 32.761L48.5562 31.9906L49.0225 30.0181Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 30,
    width: 5,
    height: 3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8418 32.4897L49.5791 32.1912C49.0501 32.0662 48.7181 31.5282 48.8432 30.9989C48.9683 30.4696 49.5061 30.1368 50.0351 30.2619L51.2978 30.5604C51.8268 30.6854 52.1587 31.2237 52.0336 31.753C51.9085 32.2824 51.3791 32.6167 50.8418 32.4897Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0713 30.034L48.6152 31.9634L51.8056 32.7176L52.2617 30.7882L49.0713 30.034Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 22,
    width: 11,
    height: 11
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1133 22.6003L42.2609 24.5262L40.3148 32.7596L32.1671 30.8337L34.1133 22.6003Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 23,
    width: 10,
    height: 9
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.142 27.0332L39.4616 26.636C39.2398 26.5836 39.0945 26.36 39.149 26.1295L39.5627 24.3794C39.6152 24.1572 39.4803 23.9273 39.2498 23.8728L37.0404 23.3505C36.8186 23.2981 36.5886 23.433 36.5341 23.6635L36.1204 25.4136C36.068 25.6354 35.8444 25.781 35.6142 25.7266L33.9421 25.3313C33.7204 25.2789 33.49 25.4137 33.4356 25.6442L32.9129 27.8553C32.8604 28.0774 32.9953 28.3074 33.2258 28.3619L34.9062 28.7591C35.128 28.8115 35.2732 29.0351 35.2188 29.2656L34.8211 30.9477C34.7687 31.1695 34.9035 31.3998 35.134 31.4543L37.3435 31.9766C37.5652 32.029 37.7952 31.8941 37.8497 31.6636L38.2473 29.9815C38.2997 29.7597 38.5234 29.6141 38.7536 29.6685L40.4344 30.0658C40.6561 30.1183 40.8861 29.9834 40.9406 29.7529L41.4633 27.5418C41.5094 27.3093 41.3725 27.0877 41.142 27.0332Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1398 22.6649L32.2247 30.7666L40.2524 32.6642L42.1675 24.5625L34.1398 22.6649Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 30,
    width: 5,
    height: 5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6326 30.4034L58.8059 31.1535L58.076 34.2411L54.9027 33.491L55.6326 30.4034Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 30,
    width: 4,
    height: 4
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.367 32.6638C58.3552 32.7137 58.3412 32.7627 58.3244 32.8111C58.3077 32.8595 58.289 32.9071 58.2678 32.9534C58.2465 33 58.2231 33.0454 58.1974 33.0896C58.1718 33.1337 58.1439 33.1767 58.114 33.2181C58.084 33.2598 58.0522 33.2997 58.0184 33.338C57.9846 33.3764 57.9487 33.4128 57.9115 33.4475C57.8739 33.4825 57.835 33.5154 57.7944 33.5465C57.7538 33.5776 57.7116 33.6065 57.6681 33.6334C57.6246 33.6602 57.5798 33.685 57.5342 33.7075C57.4882 33.7299 57.4414 33.7499 57.3933 33.7679C57.3456 33.7856 57.2969 33.8014 57.2475 33.8145C57.1981 33.8275 57.1482 33.838 57.0978 33.8463C57.0474 33.8545 56.9965 33.8602 56.9455 33.8633C56.8945 33.8665 56.8435 33.8672 56.7922 33.8653C56.7414 33.8636 56.6904 33.8593 56.6396 33.8526C56.5893 33.8456 56.5391 33.8363 56.4892 33.8245C56.4396 33.8127 56.3906 33.7987 56.3421 33.7823C56.2937 33.7655 56.2465 33.7466 56.1999 33.7253C56.1533 33.704 56.1079 33.6806 56.0638 33.6549C56.0196 33.6293 55.977 33.6015 55.9356 33.5716C55.8939 33.5415 55.854 33.5098 55.816 33.4761C55.7776 33.4422 55.7408 33.4063 55.7061 33.3691C55.6715 33.3316 55.6383 33.2926 55.6075 33.2521C55.5764 33.2115 55.5475 33.1692 55.5206 33.1257C55.4938 33.0823 55.4693 33.0376 55.4466 32.9915C55.4242 32.9455 55.4042 32.8987 55.3862 32.8506C55.3684 32.8029 55.353 32.7543 55.34 32.7049C55.3269 32.6555 55.316 32.6055 55.3082 32.5548C55.3 32.5044 55.2943 32.4536 55.2911 32.4026C55.288 32.3516 55.2873 32.3005 55.2892 32.2493C55.2909 32.1984 55.2952 32.1474 55.3019 32.0967C55.3089 32.046 55.3183 31.9958 55.3301 31.9459C55.3418 31.8963 55.3559 31.8473 55.3723 31.7988C55.3891 31.7504 55.4081 31.7029 55.4293 31.6567C55.4505 31.61 55.474 31.5647 55.4997 31.5205C55.5253 31.4763 55.5531 31.4334 55.5831 31.392C55.6128 31.3502 55.6448 31.3104 55.6787 31.272C55.7125 31.2337 55.748 31.1972 55.7853 31.1621C55.8228 31.1275 55.8617 31.0946 55.9023 31.0635C55.9433 31.0325 55.9852 31.0035 56.0286 30.9766C56.0721 30.9497 56.1169 30.925 56.1629 30.9026C56.2085 30.8801 56.2557 30.8601 56.3035 30.8421C56.3512 30.824 56.4001 30.8087 56.4496 30.7956C56.4987 30.7824 56.5486 30.7719 56.5993 30.7638C56.6497 30.7555 56.7002 30.7498 56.7512 30.7466C56.8022 30.7435 56.8533 30.7428 56.9045 30.7447C56.9557 30.7465 57.0064 30.7507 57.0571 30.7574C57.1078 30.7644 57.158 30.7738 57.2075 30.7855C57.2575 30.7973 57.3065 30.8114 57.3546 30.8277C57.403 30.8445 57.4505 30.8635 57.4968 30.8847C57.5434 30.9059 57.5888 30.9294 57.633 30.9551C57.6771 30.9807 57.7201 31.0085 57.7615 31.0385C57.8029 31.0684 57.8428 31.1002 57.8811 31.134C57.9194 31.1678 57.956 31.2033 57.9906 31.2409C58.0256 31.2785 58.0585 31.3174 58.0896 31.358C58.1203 31.3985 58.1492 31.4407 58.1761 31.4842C58.203 31.5277 58.2278 31.5725 58.2501 31.6185C58.2725 31.6644 58.2926 31.7113 58.3107 31.759C58.3283 31.8071 58.344 31.8557 58.3571 31.9052C58.3702 31.9546 58.3807 32.0045 58.3889 32.0552C58.3971 32.1056 58.4028 32.1565 58.4059 32.2075C58.4091 32.2584 58.4097 32.3095 58.4079 32.3607C58.4061 32.4116 58.4015 32.4625 58.3948 32.5133C58.3881 32.5641 58.3788 32.6142 58.367 32.6638Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6892 30.4266L54.9709 33.4656L58.0078 34.1834L58.7262 31.1445L55.6892 30.4266Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 31,
    width: 5,
    height: 5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9498 31.6604L64.0373 32.3902L63.3075 35.4777L60.22 34.7479L60.9498 31.6604Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 31,
    width: 4,
    height: 5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6477 33.912C63.6359 33.9619 63.6218 34.0109 63.605 34.0593C63.5886 34.1078 63.5696 34.1553 63.5484 34.2016C63.5271 34.2482 63.5037 34.2936 63.478 34.3378C63.4524 34.3819 63.4245 34.4249 63.3946 34.4663C63.3646 34.508 63.3329 34.5479 63.299 34.5862C63.2652 34.6246 63.2297 34.6611 63.1921 34.6957C63.1548 34.7308 63.1156 34.7636 63.075 34.7947C63.0344 34.8258 62.9925 34.8548 62.949 34.8817C62.9055 34.9085 62.8608 34.9333 62.8148 34.9557C62.7688 34.9781 62.722 34.9981 62.6742 35.0162C62.6262 35.0339 62.5775 35.0496 62.5281 35.0627C62.4787 35.0757 62.4288 35.0862 62.3784 35.0945C62.328 35.1027 62.2771 35.1084 62.2261 35.1116C62.1752 35.1147 62.1241 35.1154 62.0732 35.1136C62.022 35.1118 61.9713 35.1076 61.9206 35.1009C61.8699 35.0938 61.8197 35.0845 61.7701 35.0727C61.7202 35.061 61.6712 35.0469 61.6227 35.0305C61.5747 35.0138 61.5272 34.9948 61.4805 34.9735C61.4343 34.9523 61.3889 34.9289 61.3447 34.9032C61.3005 34.8776 61.2576 34.8497 61.2162 34.8198C61.1748 34.7898 61.1349 34.7581 61.0966 34.7243C61.0582 34.6905 61.0218 34.6546 60.9867 34.6173C60.9521 34.5798 60.9192 34.5409 60.8881 34.5003C60.857 34.4597 60.8281 34.4175 60.8012 34.374C60.7747 34.3305 60.7499 34.2858 60.7275 34.2398C60.7052 34.1938 60.6848 34.1469 60.6671 34.0989C60.649 34.0511 60.6336 34.0025 60.6206 33.9531C60.6075 33.9037 60.597 33.8538 60.5888 33.803C60.5806 33.7526 60.5749 33.7018 60.5718 33.6508C60.5686 33.5998 60.5679 33.5487 60.5698 33.4975C60.5715 33.4466 60.5758 33.3957 60.5828 33.345C60.5895 33.2942 60.5989 33.2441 60.6107 33.1941C60.6224 33.1446 60.6365 33.0955 60.6532 33.0471C60.6697 32.9987 60.6887 32.9512 60.7099 32.9049C60.7311 32.8583 60.7546 32.8129 60.7803 32.7687C60.8059 32.7245 60.8338 32.6816 60.8637 32.6402C60.8937 32.5985 60.9254 32.5586 60.9593 32.5202C60.9931 32.4819 61.0286 32.4454 61.0662 32.4104C61.1034 32.3757 61.1427 32.3429 61.1833 32.3118C61.2239 32.2807 61.2661 32.2518 61.3093 32.2248C61.3527 32.198 61.3975 32.1732 61.4435 32.1508C61.4895 32.1284 61.5363 32.1083 61.5841 32.0903C61.6322 32.0723 61.6808 32.0569 61.7302 32.0438C61.7796 32.0307 61.8295 32.0202 61.8799 32.012C61.9303 32.0037 61.9812 31.9981 62.0322 31.9949C62.0831 31.9918 62.1342 31.9911 62.1851 31.9929C62.2363 31.9947 62.2873 31.999 62.3377 32.0056C62.3884 32.0126 62.4386 32.022 62.4885 32.0338C62.5381 32.0455 62.5871 32.0596 62.6356 32.076C62.684 32.0927 62.7311 32.1117 62.7778 32.133C62.824 32.1542 62.8694 32.1776 62.9136 32.2033C62.9578 32.2289 63.0007 32.2568 63.0421 32.2867C63.0835 32.3166 63.1234 32.3484 63.1617 32.3822C63.2001 32.416 63.2366 32.4515 63.2716 32.4892C63.3062 32.5267 63.3391 32.5656 63.3702 32.6062C63.4013 32.6468 63.4302 32.689 63.4571 32.7325C63.4839 32.776 63.5084 32.8207 63.5308 32.8667C63.5535 32.9127 63.5735 32.9596 63.5913 33.0073C63.6092 33.0554 63.6247 33.1039 63.6377 33.1534C63.6508 33.2028 63.6613 33.2527 63.6695 33.3034C63.6777 33.3538 63.6834 33.4047 63.6865 33.4557C63.6897 33.5067 63.6904 33.5577 63.6885 33.609C63.6867 33.6598 63.6825 33.7108 63.6754 33.7615C63.6687 33.8123 63.6594 33.8624 63.6477 33.912Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9698 31.6748L60.2515 34.7138L63.2884 35.4316L64.0068 32.3927L60.9698 31.6748Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 28,
    width: 5,
    height: 5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9196 28.3732L62.0929 29.1233L61.3428 32.2966L58.1695 31.5465L58.9196 28.3732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 28,
    width: 4,
    height: 4
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6613 30.6933C61.6495 30.7432 61.6351 30.7922 61.6187 30.8407C61.6019 30.889 61.583 30.9362 61.5617 30.9828C61.5408 31.0295 61.5173 31.0749 61.4913 31.119C61.4657 31.1632 61.4378 31.2061 61.4082 31.2476C61.3783 31.289 61.3462 31.3288 61.3124 31.3671C61.2785 31.4058 61.243 31.4423 61.2058 31.4771C61.1681 31.512 61.1292 31.5449 61.0886 31.576C61.048 31.6071 61.0058 31.636 60.9623 31.6629C60.9188 31.6897 60.8741 31.7142 60.8281 31.7369C60.7825 31.7594 60.7356 31.7794 60.6875 31.7974C60.6398 31.8152 60.5912 31.8309 60.5417 31.844C60.4923 31.8571 60.4424 31.8675 60.392 31.8758C60.3413 31.884 60.2907 31.8897 60.2398 31.8929C60.1888 31.896 60.1377 31.8967 60.0865 31.8948C60.0356 31.8931 59.9846 31.8888 59.9339 31.8818C59.8835 31.8752 59.833 31.8657 59.7834 31.854C59.7338 31.8423 59.6845 31.8281 59.6364 31.8114C59.588 31.795 59.5404 31.776 59.4942 31.7548C59.4475 31.7336 59.4022 31.7101 59.358 31.6844C59.3138 31.6588 59.2712 31.631 59.2295 31.601C59.1881 31.5711 59.1482 31.5393 59.1099 31.5055C59.0715 31.4717 59.0351 31.4358 59.0004 31.3986C58.9654 31.361 58.9325 31.3221 58.9014 31.2815C58.8707 31.2406 58.8417 31.1988 58.8149 31.1553C58.788 31.1118 58.7632 31.067 58.7408 31.021C58.7184 30.9751 58.6984 30.9282 58.6804 30.8801C58.6627 30.8324 58.6473 30.7838 58.6343 30.7341C58.6212 30.6847 58.6104 30.6347 58.6021 30.5843C58.5942 30.5339 58.5885 30.4831 58.585 30.432C58.5819 30.381 58.5812 30.33 58.5831 30.2787C58.5849 30.2275 58.5894 30.177 58.5961 30.1262C58.6032 30.0755 58.6122 30.0253 58.624 29.9754C58.6357 29.9258 58.6501 29.8768 58.6665 29.8284C58.6833 29.78 58.702 29.7324 58.7232 29.6858C58.7444 29.6395 58.7679 29.5941 58.7935 29.5499C58.8196 29.5055 58.8474 29.4629 58.8771 29.4211C58.907 29.3797 58.9391 29.3399 58.9729 29.3015C59.0067 29.2632 59.0422 29.2267 59.0795 29.1916C59.1171 29.157 59.156 29.1241 59.1966 29.093C59.2372 29.0619 59.2794 29.033 59.3229 29.0061C59.3664 28.9793 59.4111 28.9545 59.4568 28.932C59.5027 28.9096 59.5497 28.8892 59.5977 28.8716C59.6455 28.8535 59.694 28.8381 59.7435 28.825C59.7929 28.812 59.8429 28.8011 59.8932 28.7932C59.9439 28.7851 59.9945 28.7793 60.0454 28.7761C60.0964 28.773 60.1475 28.7723 60.1987 28.7742C60.2496 28.7759 60.3006 28.7802 60.3514 28.7869C60.4017 28.7939 60.4523 28.803 60.5019 28.8147C60.5514 28.8264 60.6007 28.8409 60.6489 28.8572C60.6973 28.874 60.7448 28.893 60.791 28.9142C60.8377 28.9355 60.883 28.9589 60.9272 28.9846C60.9714 29.0102 61.014 29.038 61.0557 29.068C61.0972 29.0976 61.137 29.1297 61.1753 29.1635C61.2137 29.1973 61.2502 29.2328 61.2848 29.2704C61.3199 29.3077 61.3527 29.3469 61.3835 29.3874C61.4145 29.428 61.4435 29.4703 61.4703 29.5137C61.4972 29.5572 61.522 29.602 61.5444 29.648C61.5668 29.6939 61.5868 29.7408 61.6049 29.7886C61.6225 29.8366 61.6379 29.8852 61.651 29.9346C61.6641 29.984 61.6749 30.034 61.6832 30.0844C61.691 30.1351 61.6967 30.1856 61.6998 30.2369C61.7033 30.288 61.704 30.3391 61.7019 30.3899C61.7 30.4411 61.6958 30.4921 61.6891 30.5428C61.682 30.5935 61.673 30.6437 61.6613 30.6933Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9832 28.4557L58.2648 31.495L61.3021 32.213L62.0205 29.1737L58.9832 28.4557Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 33,
    width: 5,
    height: 5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.683 33.6047L60.8563 34.3548L60.1265 37.4423L56.9532 36.6922L57.683 33.6047Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_8184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 33,
    width: 4,
    height: 5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4301 35.9013C60.4184 35.9508 60.404 35.9998 60.3876 36.0483C60.3709 36.0967 60.3518 36.1442 60.3306 36.1908C60.3097 36.2371 60.2862 36.2825 60.2603 36.3266C60.2345 36.3711 60.2068 36.4137 60.1772 36.4552C60.1471 36.4969 60.1151 36.5367 60.0813 36.5751C60.0474 36.6134 60.0119 36.65 59.9746 36.685C59.9371 36.7196 59.8982 36.7525 59.8576 36.7836C59.817 36.8147 59.7748 36.8436 59.7313 36.8705C59.6878 36.8974 59.643 36.9222 59.597 36.9445C59.5514 36.967 59.5045 36.9874 59.4564 37.005C59.4087 37.0231 59.3601 37.0385 59.3107 37.0516C59.2612 37.0647 59.2114 37.0752 59.1609 37.0834C59.1102 37.0916 59.0597 37.0973 59.0087 37.1005C58.9577 37.1036 58.9066 37.1043 58.8554 37.1025C58.8045 37.1007 58.7536 37.0964 58.7028 37.0897C58.6524 37.0828 58.6019 37.0737 58.5523 37.0619C58.5027 37.0502 58.4534 37.0357 58.4053 37.0194C58.3569 37.0027 58.3094 36.9836 58.2631 36.9624C58.2165 36.9412 58.1711 36.9177 58.1269 36.8921C58.0828 36.8664 58.0402 36.8386 57.9984 36.8086C57.9571 36.7787 57.9171 36.747 57.8788 36.7131C57.8405 36.6793 57.8039 36.6438 57.7693 36.6062C57.7342 36.5689 57.7014 36.5297 57.6703 36.4891C57.6396 36.4486 57.6107 36.4064 57.5838 36.3629C57.5569 36.3194 57.5322 36.2746 57.5098 36.2287C57.4874 36.1827 57.4673 36.1358 57.4493 36.0881C57.4316 36.04 57.4162 35.9915 57.4031 35.942C57.39 35.8926 57.3792 35.8426 57.3711 35.7919C57.3631 35.7416 57.3574 35.691 57.354 35.6396C57.3508 35.5887 57.3502 35.5376 57.3519 35.4867C57.3538 35.4355 57.3584 35.3846 57.3651 35.3338C57.3721 35.2831 57.3811 35.2329 57.3929 35.1833C57.4047 35.1334 57.4191 35.0845 57.4355 35.036C57.4522 34.9876 57.4709 34.94 57.4921 34.8937C57.5134 34.8471 57.5368 34.8017 57.5625 34.7575C57.5885 34.7135 57.6163 34.6705 57.6459 34.629C57.6759 34.5877 57.708 34.5475 57.7418 34.5092C57.7756 34.4708 57.8112 34.4343 57.8484 34.3996C57.886 34.3646 57.9249 34.3317 57.9655 34.3006C58.0061 34.2695 58.0483 34.2406 58.0918 34.2137C58.1353 34.1869 58.18 34.1624 58.2257 34.1396C58.2717 34.1172 58.3185 34.0972 58.3666 34.0792C58.4143 34.0615 58.463 34.0457 58.5124 34.0327C58.5618 34.0196 58.6117 34.0091 58.6621 34.0008C58.7129 33.9927 58.7634 33.9869 58.8144 33.9838C58.8654 33.9806 58.9165 33.9799 58.9677 33.9818C59.0185 33.9836 59.0695 33.9878 59.1202 33.9949C59.1707 34.0015 59.2211 34.0109 59.2707 34.0226C59.3203 34.0344 59.3697 34.0485 59.4177 34.0652C59.4662 34.0816 59.5137 34.1006 59.56 34.1218C59.6066 34.1431 59.652 34.1665 59.6962 34.1922C59.7403 34.2178 59.7829 34.2456 59.8246 34.2756C59.866 34.3056 59.9059 34.3373 59.9443 34.3711C59.9826 34.4049 60.0191 34.4408 60.0538 34.478C60.0888 34.5156 60.1217 34.5545 60.1524 34.5951C60.1834 34.636 60.2124 34.6779 60.2393 34.7214C60.2661 34.7649 60.2909 34.8096 60.3133 34.8556C60.3357 34.9016 60.3558 34.9484 60.3737 34.9965C60.3915 35.0442 60.4069 35.0928 60.42 35.1422C60.433 35.1916 60.4438 35.2419 60.452 35.2924C60.4599 35.3427 60.4656 35.3935 60.4688 35.4445C60.4723 35.4956 60.4729 35.5467 60.4707 35.5978C60.469 35.6487 60.4647 35.6997 60.458 35.7504C60.451 35.8011 60.4419 35.8513 60.4301 35.9013Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7521 33.6637L57.0337 36.703L60.0709 37.4209L60.7893 34.3816L57.7521 33.6637Z",
    fill: "#662D91"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_8184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 42,
    width: 16,
    height: 17
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6287 42.6894L51.9041 46.0287L48.5963 58.1884L36.3209 54.8491L39.6287 42.6894Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7728 44.3664C42.4085 43.4512 38.9408 45.4293 38.0282 48.784C37.1156 52.1388 39.1034 55.6009 42.4677 56.5161C45.8319 57.4313 49.2992 55.4531 50.2118 52.0983C51.1244 48.7436 49.137 45.2816 45.7728 44.3664ZM41.3912 53.2936L43.2123 46.599L47.2266 51.2863L41.3912 53.2936Z",
    fill: "url(#paint0_linear_1_8184)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3072 51.1645L62.9738 51.0738C62.5875 50.9688 62.1903 51.2018 62.0876 51.5795L59.9171 59.5584C59.8122 59.9438 60.0464 60.3403 60.425 60.4433L60.7584 60.534C61.1452 60.6392 61.5418 60.4065 61.6447 60.0283L63.8152 52.0495C63.9277 51.6661 63.694 51.2698 63.3072 51.1645Z",
    fill: "url(#paint1_linear_1_8184)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4665 58.4976L61.0022 55.5691L55.1263 48.7201L52.4665 58.4976Z",
    fill: "url(#paint2_linear_1_8184)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2853 41.877L26.9899 41.7966C26.6416 41.7018 26.2851 41.9051 26.1906 42.2525L24.24 49.423C24.1454 49.7709 24.3498 50.1267 24.6981 50.2215L24.9935 50.3019C25.3423 50.3967 25.6988 50.1935 25.7934 49.8456L27.744 42.6751C27.8385 42.3277 27.6341 41.9718 27.2853 41.877Z",
    fill: "url(#paint3_linear_1_8184)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0463 52.4071L34.4347 43.6271L26.7699 46.2567L32.0463 52.4071Z",
    fill: "url(#paint4_linear_1_8184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8184",
    x1: 45.7725,
    y1: 44.3663,
    x2: 42.4674,
    y2: 56.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_8184",
    x1: 63.1406,
    y1: 51.1192,
    x2: 60.5918,
    y2: 60.4887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_8184",
    x1: 58.7292,
    y1: 49.7002,
    x2: 56.0694,
    y2: 59.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_8184",
    x1: 27.1379,
    y1: 41.8368,
    x2: 24.846,
    y2: 50.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_8184",
    x1: 31.1994,
    y1: 42.747,
    x2: 28.811,
    y2: 51.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconOne);
export default __webpack_public_path__ + "static/media/tour_icon_one.58da22efb39edf94c79585a4036c8c5f.svg";
export { ForwardRef as ReactComponent };